import { useRef, useState } from "react";
import { Reveal } from "@/lib/motion";
import { BotChat } from "@/components/landing/BotChat";
import { BOT_CHATS } from "@/lib/site";

// Drag-to-scroll for the bot-chat strip: the scrollbar is hidden, so mouse
// users need another way to move it besides the trackpad/shift+wheel.
function useDragScroll() {
  const ref = useRef(null);
  const drag = useRef({ down: false, startX: 0, startScroll: 0 });
  const [dragging, setDragging] = useState(false);

  const onDown = (e) => {
    const el = ref.current;
    if (!el) return;
    drag.current = { down: true, startX: e.pageX, startScroll: el.scrollLeft };
    setDragging(true);
  };
  const stop = () => {
    drag.current.down = false;
    setDragging(false);
  };
  const onMove = (e) => {
    if (!drag.current.down || !ref.current) return;
    e.preventDefault();
    ref.current.scrollLeft = drag.current.startScroll - (e.pageX - drag.current.startX);
  };

  return {
    ref,
    dragging,
    handlers: {
      onMouseDown: onDown,
      onMouseLeave: stop,
      onMouseUp: stop,
      onMouseMove: onMove,
    },
  };
}

export const Reviews = () => {
  const { ref: trackRef, dragging, handlers } = useDragScroll();

  return (
    <section id="examples" className="relative py-24 sm:py-32" data-testid="examples-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <Reveal className="mb-14 max-w-2xl">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-[#F0C674]/80">
            Глава 04 — Как это выглядит
          </p>
          <h2 className="font-serif text-4xl font-bold text-[#EDE6D3] sm:text-5xl lg:text-6xl">
            Примеры <span className="text-gold-gradient">разборов</span>
          </h2>
          <p className="mt-4 text-[#EDE6D3]/60">
            Так выглядит настоящий диалог с Бабушкой Варварой в боте.
          </p>
        </Reveal>

        {/* Real-looking MAX bot conversations — drag with the mouse or swipe */}
        <div className="relative">
          <div
            ref={trackRef}
            {...handlers}
            className={`flex items-stretch gap-6 overflow-x-auto pb-4 select-none [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${
              dragging ? "cursor-grabbing snap-none" : "cursor-grab snap-x"
            }`}
          >
            {BOT_CHATS.map((chat, i) => (
              <Reveal key={i} delay={i * 0.1} className={dragging ? "" : "snap-start"}>
                <BotChat chat={chat} testId={`bot-chat-${i}`} />
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
